module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('button', {
    staticClass: "right",
    attrs: {
      "disabled": !_vm.isStarted
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.moveFlag('right')
      }
    }
  }, [(_vm.flagState.right === -1) ? _c('span', [_vm._v("↑")]) : _c('span', [_vm._v("↓")])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('button', {
    staticClass: "center",
    attrs: {
      "disabled": !_vm.isStarted
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.moveFlag('center')
      }
    }
  }, [_c('span', [_vm._v("Keep")])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('button', {
    staticClass: "left",
    attrs: {
      "disabled": !_vm.isStarted
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.moveFlag('left')
      }
    }
  }, [(_vm.flagState.left === -1) ? _c('span', [_vm._v("↑")]) : _c('span', [_vm._v("↓")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-548b3dde"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Buttons.vue
// module id = 28
// module chunks = 0